// Pure helpers for the Skills page (T-350, owner request 2026-11-03): order, filter and label the third-party
// day-trader-skill pack. Data: src/data/dayTraderSkills.js (generated by scripts/build_skill_catalog.py).
// Tested with node --test (frontend/tests/skillCatalog.test.mjs). No network, no side effects.

// The pack's own one-trade pipeline order (README "How to use it"), then the side tools.
export const PIPELINE = ['trader-scanner', 'trader-news', 'trader-entry', 'trader-exit', 'trader-timemachine',
  'trader-budget', 'trader-risk', 'trader-broker', 'trader-alerts', 'trader-analyst', 'trader-pelosi']

// Saferfunds-fit verdicts (Claude review 2026-11-03, T-350): colour and a plain label.
export const VERDICT = {
  RESEARCH: { color: '#34d399', label: 'RESEARCH LEAD', hint: 'Worth a backtest on our own bars with friction' },
  REFERENCE: { color: '#60a5fa', label: 'REFERENCE', hint: 'Read for ideas; not wired into anything' },
  NOT_FOR_ENGINE: { color: '#f87171', label: 'NOT FOR ENGINE', hint: 'Conflicts with a Saferfunds rule' },
  UNREVIEWED: { color: '#94a3b8', label: 'UNREVIEWED', hint: 'Not reviewed yet' },
}

/** Skills in pipeline order; unknown ids go last, alphabetically. */
export function orderSkills(skills) {
  const rank = (id) => { const i = PIPELINE.indexOf(id); return i < 0 ? PIPELINE.length : i }
  return [...(skills || [])].sort((a, b) => rank(a.id) - rank(b.id) || a.id.localeCompare(b.id))
}

/** Filter by verdict ('ALL' keeps everything) and a case-insensitive text search over command, description and fit note. */
export function filterSkills(skills, { verdict = 'ALL', query = '' } = {}) {
  const q = query.trim().toLowerCase()
  return (skills || []).filter(s => (verdict === 'ALL' || s.fit?.verdict === verdict) &&
    (!q || [s.command, s.description, s.fit?.note].join(' ').toLowerCase().includes(q)))
}

/** Count per verdict, for the filter chips. */
export function verdictCounts(skills) {
  const out = {}
  for (const s of skills || []) out[s.fit?.verdict || 'UNREVIEWED'] = (out[s.fit?.verdict || 'UNREVIEWED'] || 0) + 1
  return out
}
